// extracted by mini-css-extract-plugin
export default {"box":"VrpzkXbkpiioiz6V3ToC","text":"S5JcpboO5eNcAR8m5RPj"};